import { render, staticRenderFns } from "./ContactPerson.vue?vue&type=template&id=103aee97&scoped=true&"
import script from "./ContactPerson.vue?vue&type=script&lang=js&"
export * from "./ContactPerson.vue?vue&type=script&lang=js&"
import style0 from "./ContactPerson.vue?vue&type=style&index=0&id=103aee97&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103aee97",
  null
  
)

export default component.exports